import React from "react";

import { BodyTypeCellContent as Content } from "../components";

import base from "./base";

import { Column, ColumnId } from ".";

function bodyType({ width, onResize }: Column.Options) {
	return base(ColumnId.BodyType, (item) => <Content item={item} />, {
		width,

		onResize: onResize as (
			columnWidth?: number | undefined,
			dataKey?: string | undefined,
		) => void,
	});
}

export default bodyType;
